
import { Component, Prop, Vue } from 'vue-property-decorator';

import FormP1 from "./FormP1.vue";
import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
import moment from 'moment';
import { courtLocationInfoType } from '@/types/Common';
import { stepInfoType } from '@/types/Application';
import { incapablePdfType, minorIncapableInfoType, minorPdfType } from '@/types/Application/MinorIncapable';


@Component({
    components:{
        UnderlineForm,
        CheckBox,
        FormP1
    }
})

export default class FormPgt extends Vue {    

    @Prop({required:false, default:false})
    exhibit!: boolean
    
    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.State
    public steps!: stepInfoType[]; 

    @applicationState.State
    public deceasedName!: string;

    @applicationState.State
    public applicantName!: string;

    @applicationState.State
    public applicationLocation!: courtLocationInfoType;

    grantType = "Grant of Administration Without Will Annexed";

    courtName = '';
    deceasedDateOfDeath ='';  
    deceasedAddress = {};
    applicantRelation = '';
    applicantMailingAddress = {};
    applicantServiceAddress = {};
    applicantServiceEmail = '';
    applicantServicePhone = '';
    currentDate = '';
    minorsList: minorPdfType[] = [];
    incapablesList: incapablePdfType[] = []; 


    dataReady=false

    public getFormData() {

        this.courtName = this.applicationLocation.name??''

        //___Deceased        
        const deceasedInfo = this.steps[this.stPgNo.DECEASED._StepNo].result?.informationAboutDeceasedSurvey?.data;
        this.deceasedDateOfDeath = deceasedInfo?.deceasedDateOfDeath;
        this.deceasedAddress = deceasedInfo?.deceasedAddress??{};

        //___Applicant
        const applicantInfo = this.steps[this.stPgNo.APPLICANT._StepNo].result?.applicantInfoSurvey?.data;
        this.applicantMailingAddress = applicantInfo?.applicantMailingAddress && applicantInfo?.applicantOrdinaryAddressReceiveMail=='y'?
            applicantInfo?.applicantMailingAddress : (applicantInfo?.applicantOrdinaryAddress??{})

        //___Service
        const serviceInfo = this.steps[this.stPgNo.APPLICANT._StepNo].result?.applicantServiceSurvey?.data;       
        this.applicantServiceAddress = serviceInfo?.applicantServiceAddress??{}        
        
        this.applicantServiceEmail = serviceInfo?.applicantServiceEmail??'';
        this.applicantServicePhone = serviceInfo?.applicantServicePhone??'';

        //Minor and/or Incapable
        const relatedStep = this.steps[this.stPgNo.RELATIONS._StepNo]
        const minorAndIncapableInfo: minorIncapableInfoType = Vue.filter('getMinorAndIncapableInfo')(relatedStep);
        const spouseList = relatedStep.result.spouseSurvey?.data?? []
        const childList = relatedStep.result.childrenSurvey?.data?? []
        const creditorList = relatedStep.result.creditorSurvey?.data?? []
        this.applicantRelation = Vue.filter('getApplicantRelation')(relatedStep, this.applicantName)
        // sconsole.log(minorAndIncapableInfo)
        if(minorAndIncapableInfo.hasSpouse)
            spouseList.forEach(spouse => { 
                if(minorAndIncapableInfo.spouse.minorAll.includes(spouse.spouseName)){
                    let mailingAddress = spouse.spouseIsAdultNoResidentialAddress;                   
                    if(spouse.spouseIsAdultNoResidentialReceiveMail == 'n' && spouse.spouseIsAdultNoHasMailingAddress == 'y'){
                        mailingAddress = spouse.spouseIsAdultNoMailingAddress;
                    }
                    let guardianMailingAddress = spouse.spouseGuardianResidentialAddress;
                    if(spouse.spouseHasGuardian == 'y' && spouse.spouseGuardianResidentialReceiveMail == 'n' && spouse.spouseGuardianHasMailingAddress == 'y'){
                        guardianMailingAddress = spouse.spouseGuardianMailingAddress;
                    }
                    const minor: minorPdfType = {
                        name: spouse.spouseName,
                        relation: 'spouse',
                        dob: spouse.spouseIsAdultNoDOB,
                        residentialAddress: spouse.spouseIsAdultNoResidentialAddress,
                        mailingAddress: mailingAddress,
                        email: spouse.spouseIsAdultNoEmailAddress?spouse.spouseIsAdultNoEmailAddress: 'None',
                        fax: spouse.spouseIsAdultNoFaxNumber?spouse.spouseIsAdultNoFaxNumber: 'None',

                        hasGuardian: spouse.spouseHasGuardian == 'y',    
                        guardianName: spouse.spouseHasGuardian == 'y' && spouse.spouseGuardianName? spouse.spouseGuardianName: 'None', 
                        guardianResidentialAddress: spouse.spouseGuardianResidentialAddress,
                        guardianMailingAddress: guardianMailingAddress,
                        guardianEmail: spouse.spouseGuardianEmailAddress?spouse.spouseGuardianEmailAddress: 'None',
                        guardianFax: spouse.spouseGuardianFaxNumber?spouse.spouseGuardianFaxNumber: 'None'
                    }
                    this.minorsList.push(minor)
                }
                else if(minorAndIncapableInfo.spouse.incapableAll.includes(spouse.spouseName)){
                    let mailingAddress = spouse.spouseIsCompetentNoResidentialAddress;                   
                    if(spouse.spouseIsCompetentNoResidentialReceiveMail == 'n' && spouse.spouseIsCompetentNoHasMailingAddress == 'y'){
                        mailingAddress = spouse.spouseIsCompetentNoMailingAddress;
                    }

                    let nomineeMailingAddress = spouse.spouseNomineeResidentialAddress;
                    if(spouse.spouseIsCompetent == 'n' && spouse.spouseHasNominee == 'y' && 
                        spouse.spouseNomineeResidentialReceiveMail == 'n' && spouse.spouseNomineeHasMailingAddress == 'y'){
                            nomineeMailingAddress = spouse.spouseNomineeMailingAddress;
                    }

                    const incapable: incapablePdfType = {
                        name: spouse.spouseName,
                        relation: 'spouse',
                        dob: spouse.spouseIsCompetentNoDOB,
                        residentialAddress: spouse.spouseIsCompetentNoResidentialAddress,
                        mailingAddress: mailingAddress,
                        email: spouse.spouseIsCompetentNoEmailAddress?spouse.spouseIsCompetentNoEmailAddress: 'None',
                        fax: spouse.spouseIsCompetentNoFaxNumber?spouse.spouseIsCompetentNoFaxNumber: 'None',

                        hasNominee: spouse.spouseHasNominee == 'y',
                        nomineeName: spouse.spouseHasNominee == 'y' && spouse.spouseNomineeName? spouse.spouseNomineeName: 'None',
                        nomineeFormal: spouse.spouseNomineeFormal =='y',
                        nomineeResidentialAddress: spouse.spouseNomineeResidentialAddress,    
                        nomineeMailingAddress: nomineeMailingAddress,
                        nomineeEmail: spouse.spouseNomineeEmailAddress?spouse.spouseNomineeEmailAddress: 'None',
                        nomineeFax: spouse.spouseNomineeFaxNumber?spouse.spouseNomineeFaxNumber: 'None'
                    }
                    this.incapablesList.push(incapable)
                }
            })

        if(minorAndIncapableInfo.hasChildren)
            childList.forEach(child => { 
                if(minorAndIncapableInfo.children.minorAll.includes(child.childName)){
                    let mailingAddress = child.childIsAdultNoResidentialAddress;                   
                    if(child.childIsAdultNoResidentialReceiveMail == 'n' && child.childIsAdultNoHasMailingAddress == 'y'){
                        mailingAddress = child.childIsAdultNoMailingAddress;
                    }
                    let guardianMailingAddress = child.childGuardianResidentialAddress;
                    if(child.childHasGuardian == 'y' && child.childGuardianResidentialReceiveMail == 'n' && child.childGuardianHasMailingAddress == 'y'){
                        guardianMailingAddress = child.childGuardianMailingAddress;
                    }
                    const minor: minorPdfType = {
                        name: child.childName,
                        relation: 'child',
                        dob: child.childIsAdultNoDOB,
                        residentialAddress: child.childIsAdultNoResidentialAddress,
                        mailingAddress: mailingAddress,
                        email: child.childIsAdultNoEmailAddress?child.childIsAdultNoEmailAddress:'None',
                        fax: child.childIsAdultNoFaxNumber?child.childIsAdultNoFaxNumber:'None',

                        hasGuardian: child.childHasGuardian == 'y',    
                        guardianName: child.childGuardianName && child.childHasGuardian == 'y'? child.childGuardianName:'None',
                        guardianResidentialAddress: child.childGuardianResidentialAddress,
                        guardianMailingAddress: guardianMailingAddress,
                        guardianEmail: child.childGuardianEmailAddress?child.childGuardianEmailAddress:'None',
                        guardianFax: child.childGuardianFaxNumber?child.childGuardianFaxNumber:'None'
                    }
                    this.minorsList.push(minor)
                }
                else if(minorAndIncapableInfo.children.incapableAll.includes(child.childName)){
                    let mailingAddress = child.childIsCompetentNoResidentialAddress;                   
                    if(child.childIsCompetentNoResidentialReceiveMail == 'n' && child.childIsCompetentNoHasMailingAddress == 'y'){
                        mailingAddress = child.childIsCompetentNoMailingAddress;
                    }

                    let nomineeMailingAddress = child.childNomineeResidentialAddress;
                    if(child.childIsCompetent == 'n' && child.childHasNominee == 'y' && 
                        child.childNomineeResidentialReceiveMail == 'n' && child.childNomineeHasMailingAddress == 'y'){
                            nomineeMailingAddress = child.childNomineeMailingAddress;
                    }

                    const incapable: incapablePdfType = {
                        name: child.childName,
                        relation: 'child',
                        dob: child.childIsCompetentNoDOB,
                        residentialAddress: child.childIsCompetentNoResidentialAddress,
                        mailingAddress: mailingAddress,
                        email: child.childIsCompetentNoEmailAddress?child.childIsCompetentNoEmailAddress: 'None',
                        fax: child.childIsCompetentNoFaxNumber?child.childIsCompetentNoFaxNumber: 'None',

                        hasNominee: child.childHasNominee=='y',
                        nomineeName: child.childHasNominee=='y' && child.childNomineeName? child.childNomineeName: 'None',
                        nomineeFormal: child.childNomineeFormal =='y',
                        nomineeResidentialAddress: child.childNomineeResidentialAddress,
                        nomineeMailingAddress: nomineeMailingAddress,
                        nomineeEmail: child.childNomineeEmailAddress?child.childNomineeEmailAddress: 'None',
                        nomineeFax: child.childNomineeFaxNumber?child.childNomineeFaxNumber: 'None'
                    }
                    this.incapablesList.push(incapable)
                }
            })

        if(minorAndIncapableInfo.hasCreditor)
            creditorList.forEach(creditor => { 
                if(minorAndIncapableInfo.creditor.minorAll.includes(creditor.creditorPersonName)){
                    let mailingAddress = creditor.creditorPersonIsAdultNoResidentialAddress;                   
                    if(creditor.creditorPersonIsAdultNoResidentialReceiveMail == 'n' && creditor.creditorPersonIsAdultNoHasMailingAddress == 'y'){
                        mailingAddress = creditor.creditorPersonIsAdultNoMailingAddress;
                    }
                    let guardianMailingAddress = creditor.creditorPersonGuardianResidentialAddress;
                    if(creditor.creditorPersonHasGuardian == 'y' && creditor.creditorPersonGuardianResidentialReceiveMail == 'n' && creditor.creditorPersonGuardianHasMailingAddress == 'y'){
                        guardianMailingAddress = creditor.creditorPersonGuardianMailingAddress;
                    }
                    const minor: minorPdfType = {
                        name: creditor.creditorPersonName,
                        relation: 'creditor',
                        dob: creditor.creditorPersonIsAdultNoDOB,
                        residentialAddress: creditor.creditorPersonIsAdultNoResidentialAddress,
                        mailingAddress: mailingAddress,
                        email: creditor.creditorPersonIsAdultNoEmailAddress?creditor.creditorPersonIsAdultNoEmailAddress: 'None',
                        fax: creditor.creditorPersonIsAdultNoFaxNumber?creditor.creditorPersonIsAdultNoFaxNumber: 'None',

                        hasGuardian: creditor.creditorPersonHasGuardian == 'y',    
                        guardianName: creditor.creditorPersonHasGuardian == 'y' && creditor.creditorPersonGuardianName? creditor.creditorPersonGuardianName: 'None', 
                        guardianResidentialAddress: creditor.creditorPersonGuardianResidentialAddress,
                        guardianMailingAddress: guardianMailingAddress,
                        guardianEmail: creditor.creditorPersonGuardianEmailAddress?creditor.creditorPersonGuardianEmailAddress: 'None',
                        guardianFax: creditor.creditorPersonGuardianFaxNumber?creditor.creditorPersonGuardianFaxNumber: 'None' 
                    }
                    this.minorsList.push(minor)
                }
                else if(minorAndIncapableInfo.creditor.incapableAll.includes(creditor.creditorPersonName)){

                    let mailingAddress = creditor.creditorPersonIsCompetentNoResidentialAddress;                   
                    if(creditor.creditorPersonIsCompetentNoResidentialReceiveMail == 'n' && creditor.creditorPersonIsCompetentNoHasMailingAddress == 'y'){
                        mailingAddress = creditor.creditorPersonIsCompetentNoMailingAddress;
                    }

                    let nomineeMailingAddress = creditor.creditorPersonNomineeResidentialAddress;
                    if(creditor.creditorPersonIsCompetent == 'n' && creditor.creditorPersonHasNominee == 'y' && 
                        creditor.creditorPersonNomineeResidentialReceiveMail == 'n' && creditor.creditorPersonNomineeHasMailingAddress == 'y'){
                            nomineeMailingAddress = creditor.creditorPersonNomineeMailingAddress;
                    }
                    
                    const incapable: incapablePdfType = {
                        name: creditor.creditorPersonName,
                        relation: 'creditor',
                        dob: creditor.creditorPersonIsCompetentNoDOB,
                        residentialAddress: creditor.creditorPersonIsCompetentNoResidentialAddress,
                        mailingAddress: mailingAddress,
                        email: creditor.creditorPersonIsCompetentNoEmailAddress?creditor.creditorPersonIsCompetentNoEmailAddress : 'None',
                        fax: creditor.creditorPersonIsCompetentNoFaxNumber?creditor.creditorPersonIsCompetentNoFaxNumber : 'None',
                        
                        hasNominee: creditor.creditorPersonHasNominee == 'y',
                        nomineeName: creditor.creditorPersonHasNominee == 'y' && creditor.creditorPersonNomineeName? creditor.creditorPersonNomineeName : 'None',
                        nomineeFormal: creditor.creditorPersonNomineeFormal == 'y',
                        nomineeResidentialAddress: creditor.creditorPersonNomineeResidentialAddress,
                        nomineeMailingAddress: nomineeMailingAddress,
                        nomineeEmail: creditor.creditorPersonNomineeEmailAddress?creditor.creditorPersonNomineeEmailAddress : 'None',
                        nomineeFax: creditor.creditorPersonNomineeFaxNumber?creditor.creditorPersonNomineeFaxNumber : 'None'
                    }
                    this.incapablesList.push(incapable)
                }
            })
        
    }

    mounted(){ 
        this.dataReady=false
        this.currentDate = moment().format("MMMM DD, yyyy")
        this.getFormData();
        this.dataReady=true
        Vue.nextTick(() => this.onPrint(false));
    }

    public onPrint(openDownload) {                
        const elPGT= document.getElementById("print-pgt");
        const elP1= document.getElementById("print");        
        const bodyPGT = Vue.filter('printPdf')(elPGT.innerHTML,`"Generated by “Representation Grant” on ${this.currentDate}.         "`,`"PGT Letter "`, `"Letter to the Public Guardian & Trustee (PGT) of British Columbia"`);
        const bodyP1 = Vue.filter('printPdf')(elP1.innerHTML,`"Generated by “Representation Grant” on ${this.currentDate}.         "`,`"P1 "`);
        this.$emit('onPrint',[...bodyPGT , ...bodyP1],openDownload)
    }

}
